import './select-items-error-dialog.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { BModal } from 'bootstrap-vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { Item, SearchResult } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { CANCEL_ALL_SELECT_ITEM, CANCEL_ONE_SELECT_ITEM, RETRY_ALL_SELECT_ITEM, RETRY_ONE_SELECT_ITEM } from '../../events';
import { BasicItemCard } from '../../cards/item/basic-item-card';

export interface ItemSelectionFailure {
    item: Item | SearchResult
    info?: string,
    currentlyUploading?: boolean,
} 

@Component({
    components: {
        sBasicItemCard: BasicItemCard,
    },
    props: {
        itemsWhoFailed: {
            type: Array as PropType<ItemSelectionFailure[]>
        },
        title: {
            type: String,
            default: "selectItemErrorDialog.title",
        },
        description: {
            type: String,
            default: "selectItemErrorDialog.description",
        },
    },
    template: require('./select-items-error-dialog.html')
})
export class SelectItemsErrorDialog extends ReactiveVue {

    private itemsWhoFailed: ItemSelectionFailure[]
    private title: String
    private description: String

    private loadingIcon = faCircleNotch

    public $refs: {
        modal: BModal,
    }

    private onRetryAll() {
        this.$emit(RETRY_ALL_SELECT_ITEM)
    }

    private onCancelAll() {
        this.$emit(CANCEL_ALL_SELECT_ITEM)
    }

    private onRetry(index: number) {
        this.$emit(RETRY_ONE_SELECT_ITEM, index)
    }

    private onCancel(index: number) {
        this.$emit(CANCEL_ONE_SELECT_ITEM, index)
    }

    private onHide(event) {
        this.$emit('hidden', event)
    }

    private isUploading(index: number): boolean {
        return this.itemsWhoFailed?.[index]?.currentlyUploading ?? false
    }

    private get someItemCurrentlyUploading(): boolean {
        return this.itemsWhoFailed.findIndex(failedItem => {
            return failedItem.currentlyUploading
        }) > -1
    }

    private get computedDescription(): string {
        return (this.$t(this.description as string, [this.itemsWhoFailed.length]) ?? this.description) as string
    }

    public closeModal() {
        this.$refs.modal.hide()
    }

    public openModal() {
        this.$refs.modal.show()
    }
}